// Organization-specific form styles (extends shared form styles via theme-aware hook)
import { StyleSheet } from 'react-native';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';
import { useSharedFormStyles } from '@/components/common/admin/desktop/sharedFormStyles';

/**
 * Theme-aware organization form stylesheet hook.
 *
 * Wraps the shared form styles with organization-specific overrides (container
 * padding, section vertical padding, payment account field). All colors flow
 * from `admin.dataTable.*` so dark/light toggles propagate automatically.
 */
export const useOrganizationFormStyles = () => {
  const shared = useSharedFormStyles();
  const overrides = useOrganizationOverrideStyles();
  return { ...shared, ...overrides };
};

const useOrganizationOverrideStyles = () =>
  useThemedStyles(({ components }) => {
    const admin = components.admin;
    return StyleSheet.create({
      container: {
        flex: 1,
        paddingHorizontal: 20,
      },
      section: {
        paddingVertical: 20,
        borderBottomWidth: 1,
        borderBottomColor: admin.dataTable.border,
      },
      paymentAccountField: {
        marginBottom: 16,
      },
    });
  });
